import { Appearance, DraftConfiguration, PrintArea } from '@/types';

export const checkTextNotAllowedForView = (
  configurations: DraftConfiguration[],
  printAreas: PrintArea[],
  viewId: string
) => {
  if (configurations.length > 0) {
    const isTextNotAllowedForView = configurations.some(
      (config) => !config.printArea.restrictions.textAllowed
    );
    return { isTextNotAllowedForView, undefined } as const;
  } else {
    const activePrintArea = printAreas.find(
      (printArea) => !printArea.deprecated && printArea.defaultView.id === viewId
    );

    const isTextNotAllowedForView = !activePrintArea?.restrictions.textAllowed;
    // activePrintArea used for tests
    return { isTextNotAllowedForView, activePrintArea } as const;
  }
};

const getAllAppearancePrintTypeIds = (appearances: Appearance[]) => {
  const allPrintTypeIds = appearances.map((appearance) =>
    appearance.printTypes.map((printType) => printType.id)
  );

  const uniquePrintTypeIds = new Set(...allPrintTypeIds);
  return [...uniquePrintTypeIds];
};

export const checkIfPrintTextOnProduct = (appearances: Appearance[], fontIds: string[]) =>
  getAllAppearancePrintTypeIds(appearances).some((printTypeId) => fontIds.includes(printTypeId));
